import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col, Card, Button, Badge } from 'react-bootstrap';
import AuthContext from '../context/AuthContext';
import ProjectContext from '../context/ProjectContext';
import { useOrganizations } from '../hooks/useOrganizations';

const OrganizationLanding = () => {
  const { user, loading: authLoading } = useContext(AuthContext);
  const { setActiveProject } = useContext(ProjectContext);
  const { organizations = [], loading } = useOrganizations(user, authLoading);
  const history = useHistory();

  const goToProject = (project) => {
    setActiveProject(project);
    history.push('/transactions');
  };

  const goToOrgDashboard = (orgId) => {
    history.push(`/org/${orgId}/dashboard`);
  };

  if (loading || authLoading) return <div className="p-5 text-center"><i className="fas fa-spinner fa-spin fa-2x"></i></div>;

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-5">
        <div>
            <h1 className="font-weight-bold mb-1">Command Center</h1>
            <p className="text-muted">Manage your business portfolio and organizations</p>
        </div>
        {user?.type === 'admin' && (
            <Button variant="primary" onClick={() => history.push('/admin')}>
                <i className="fas fa-user-shield mr-2"></i> Admin Portal
            </Button>
        )}
      </div>

      <Row>
        {organizations.map(org => (
          <Col md={6} lg={4} key={org._id} className="mb-4">
            <Card className="h-100 shadow-sm border-0 org-card">
              <Card.Body className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <h3 className="h5 font-weight-bold text-primary mb-0">{org.name}</h3>
                    <Badge variant="light" className="border">
                        {org.projects?.length || 0} Companies
                    </Badge>
                </div>

                <div className="mb-4">
                    <div className="small text-muted text-uppercase font-weight-bold mb-2">Metrics</div>
                    <div className="d-flex justify-content-between mb-1">
                        <span className="small">Total Cash:</span>
                        <span className="small font-weight-bold">${org.summary?.totalCash?.toLocaleString() || '0'}</span>
                    </div>
                    <div className="d-flex justify-content-between">
                        <span className="small">Net Profit:</span>
                        <span className={`small font-weight-bold ${(org.summary?.totalProfit || 0) >= 0 ? 'text-success' : 'text-danger'}`}>
                            ${org.summary?.totalProfit?.toLocaleString() || '0'}
                        </span>
                    </div>
                </div>

                <div className="mt-auto">
                    <div className="small text-muted text-uppercase font-weight-bold mb-2">Shortcuts</div>
                    <div className="list-group list-group-flush mb-3">
                        {(!org.projects || org.projects.length === 0) && (
                            <div className="small text-muted py-2">No companies found</div>
                        )}
                        {org.projects && org.projects.length > 0 && org.projects.slice(0, 3).map(p => (
                            <button 
                                key={p._id} 
                                onClick={() => goToProject(p)}
                                className="list-group-item list-group-item-action py-2 px-0 border-0 small d-flex justify-content-between align-items-center"
                            >
                                <span><i className="fas fa-building mr-2 text-muted"></i>{p.name}</span>
                                <i className="fas fa-chevron-right text-muted x-small"></i>
                            </button>
                        ))}
                    </div>
                    <Button variant="outline-primary" size="sm" block onClick={() => goToOrgDashboard(org._id)}>
                        View Organization Dashboard
                    </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
        
        {organizations.length === 0 && (
            <Col className="text-center p-5">
                <div className="text-muted mb-3"><i className="fas fa-folder-open fa-3x"></i></div>
                <h4>No Organizations Found</h4>
                <p>Please contact an administrator to set up your organization.</p>
            </Col>
        )}
      </Row>

      <style dangerouslySetInnerHTML={{ __html: `
        .org-card { transition: transform 0.2s ease; border-radius: 12px; }
        .org-card:hover { transform: translateY(-5px); }
        .list-group-item-action:hover { color: #007bff; background: none !important; }
        .x-small { font-size: 0.65rem; }
      `}} />
    </div>
  );
};

export default OrganizationLanding;
